import { memo } from "react";
import PropTypes from "prop-types";
import { SearchOutlined } from "@ant-design/icons";
import SearchBarComponent from "components/SearchBar";
import { TextInput } from "components/common/Form";

const SearchBar = () => (
  <SearchBarComponent filterFields={["keyword", "status"]} isOnChangeSearch>
    <>
      <TextInput
        prefix={<SearchOutlined />}
        name="keyword"
        allowClear={false}
      />
    </>
  </SearchBarComponent>
);

SearchBar.propTypes = {
  name: PropTypes.string,
  companyValue: PropTypes.string,
};
export default memo(SearchBar);
